export default {
  needHelp: {
    id: 'asp_conversation_details_need_help',
    defaultMessage: 'Need help? {sscLink, html}',
  },
  SSCLinkLabel: {
    id: 'asp_conversation_details_seller_support_center_link_label',
    defaultMessage: 'Contact the Seller Support Center',
  },
}
